<template>
    <div>
        <mt-header :title="$route.meta.title" v-if="$route.path!='/mobile/policyDetail'&& $route.path!='/renewalNotice' && $route.path!='/policyInfo' && $route.path!='/policyInfoFile'
            && $route.path!='/wechatMarketInfo' && $route.path!='/hr' && $route.path!='/overseaApply' && $route.path!='/commNote'&& $route.path!='/weixinSweepCode'
            && $route.path!='/questionnaire'&& $route.path!='/questionnaire2' " style="position:fixed;left:0px;right:0px;top:0px;z-index: 1000">
            <div slot="left">
                <mt-button icon="back" @click="$router.go(-1)"> </mt-button>
            </div>
            <mt-button icon="more" slot="right"></mt-button>
        </mt-header>
            <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name:'mobHome',
          data(){
            return{

            }
          },
        methods:{

        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/mobile/mobHome.vue